






































































































































































































































































































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import { required, requiredIf, minLength } from 'vuelidate/lib/validators';
import MaskedInput from 'vue-masked-input';
import Navigator from '../Study/Navigator.vue';
import { bus, store, client } from '../../shared';
import { UserInfo } from '../../shared/user';
import { ToggleButton } from 'vue-js-toggle-button';
import { GrantBase, Grants, DeleteGrant, EditGrant } from '../../shared/study';
import { supportTypesGrantFunding } from '../../shared/constants';
import moment from 'moment';
import _ from 'lodash';
@Component({
  components: {
    Navigator,
    MaskedInput,
    ToggleButton,
  },
})
export default class FundingInfo extends Vue {
  $v: any;
  supportTypeOptions: any = supportTypesGrantFunding;
  supportTypesGrantFunding: any = [];
  editMode?: any = false;
  hasFunding: boolean = false;
  iidpIAIActive: any = '';
  isHidden: boolean = true;
  now: any = new Date();
  today: any = new Date(
    this.now.getFullYear(),
    this.now.getMonth(),
    this.now.getDate(),
  );
  min: any = this.now;
  form: any = {
    non_Profit: false,
    peer_Rev_Grant: false,
    fundsAva: false,
    pilot: false,
    iAIPrevApproved: false,
    isletsFunded: false,
    positionGrantAutoElig: false,
    pIConsulted: false,
    grants: [],
  };
  grants: any = {
    appId: 0,
    rowId: 0,
    grantTitle: '',
    fundingSource: '',
    grantNo: '',
    startDt: '',
   // duration: '',
   // awardAmt: '',
    supportType: '',
    supportTypeOth: '',
  };
  grantList: GrantBase[] = [];
  @Validations()
  validations: any = {
    form: {
      non_Profit: {},
      peer_Rev_Grant: {},
      fundsAva: {},
      pilot: {},
      iAIPrevApproved: {},
      isletsFunded: {},
      positionGrantAutoElig: {},
      pIConsulted: {},
    },
    grants: {
      grantTitle: {
            requiredIf: requiredIf((form: any) => form.supportType !== '9'),
            minLength: minLength(2),
      },
      fundingSource: {
          requiredIf: requiredIf((form: any) => form.supportType !== '9'),
          minLength: minLength(2),
      },
      grantNo: {
          requiredIf: requiredIf((form: any) => form.supportType !== '9'),
          minLength: minLength(2),
      },
      startDt: {
        requiredIf: requiredIf((form: any) => form.supportType !== '9'),
      },
      supportType: { required },
      supportTypeOth: {
          requiredIf: requiredIf((form: any) => form.supportType === '-9' && form.supportType !== '9'),
          minLength: minLength(2),
      },
    },
  };
  @Watch('form.non_Profit')
  onNonProfitChanged(newValue: boolean, oldValue: boolean) {
    this.$v.form.non_Profit.$touch();
  }
  @Watch('form.peer_Rev_Grant')
  onPeerRevGrantChanged(value: any) {
    this.$v.form.peer_Rev_Grant.$touch();
  }
  @Watch('form.fundsAva')
  onFundsAvaChanged(value: any) {
    this.$v.form.fundsAva.$touch();
  }
  @Watch('form.pilot')
  onPilotChanged(value: any) {
    if (value === false) {
      this.form.positionGrantAutoElig = false;
      this.form.iAIPrevApproved = false;
      this.form.isletsFunded = false;
    }
    this.$v.form.pilot.$touch();
  }
  @Watch('form.iAIPrevApproved')
  oniAIPrevApprovedChanged(value: any) {
    this.submit();
    this.$v.form.iAIPrevApproved.$touch();
  }
  @Watch('form.isletsFunded')
  onisletsFundedChanged(value: any) {
      /* if (!value && !this.form.iAIPrevApproved &&this.form.positionGrantAutoElig) {*/
    if (!value && this.form.positionGrantAutoElig) {
      this.form.pilot = true;
    } else {
      this.form.pilot = false;
    }
    this.submit();
    this.$v.form.isletsFunded.$touch();
  }
  @Watch('form.positionGrantAutoElig')
  onipositionGrantAutoEligChanged(value: any) {
    // if (value && !this.form.iAIPrevApproved && !this.form.isletsFunded) {
    if (value && !this.form.isletsFunded) {
      this.form.pilot = true;
    } else {
      this.form.pilot = false;
    }
    this.submit();
    this.$v.form.positionGrantAutoElig.$touch();
  }
  @Watch('userInfo.study.form', { deep: true })
  public formUpdated(newValue: any, oldValue: any) {
    if (newValue !== oldValue) {
      // Study Interest
      if (this.userInfo.study.form.culturedIslets != null) {
        this.form.culturedIslets = this.userInfo.study.form.culturedIslets;
      }
      if (this.userInfo.study.form.frozenIslets != null) {
        this.form.frozenIslets = this.userInfo.study.form.frozenIslets;
      }
      if (this.userInfo.study.form.unmatchedAcinar != null) {
        this.form.unmatchedAcinar = this.userInfo.study.form.unmatchedAcinar;
      }
      if (this.userInfo.study.form.histoSlides != null) {
        this.form.histoSlides = this.userInfo.study.form.histoSlides;
      }
      if (this.userInfo.study.form.serumRed != null) {
        this.form.serumRed = this.userInfo.study.form.serumRed;
      }
      if (this.userInfo.study.form.serumYellow != null) {
        this.form.serumYellow = this.userInfo.study.form.serumYellow;
      }
      if (this.userInfo.study.form.plasmaLavender != null) {
        this.form.plasmaLavender = this.userInfo.study.form.plasmaLavender;
      }
      if (this.userInfo.study.form.matchedAncillary != null) {
        this.form.matchedAncillary = this.userInfo.study.form.matchedAncillary;
      }
      if (this.userInfo.study.form.lymphNode != null) {
        this.form.lymphNode = this.userInfo.study.form.lymphNode;
      }
      if (this.userInfo.study.form.spleen != null) {
        this.form.spleen = this.userInfo.study.form.spleen;
      }
      if (this.userInfo.study.form.duodenum != null) {
        this.form.duodenum = this.userInfo.study.form.duodenum;
      }
      if (this.userInfo.study.form.matchedAcinar != null) {
        this.form.matchedAcinar = this.userInfo.study.form.matchedAcinar;
      }
      // Contact Info
      if (this.userInfo.study.form.title != null) {
        this.form.title = this.userInfo.study.form.title;
      }
      if (this.userInfo.study.form.pI_Phone != null) {
        this.form.pI_Phone = this.userInfo.study.form.pI_Phone;
      }
      if (this.userInfo.study.form.pI_Phone_Ext != null) {
        this.form.pI_Phone_Ext = this.userInfo.study.form.pI_Phone_Ext;
      }
      if (this.userInfo.study.form.pI_Email != null) {
        this.form.pI_Email = this.userInfo.study.form.pI_Email;
      }
      if (this.userInfo.study.form.textMsg != null) {
        this.form.textMsg = this.userInfo.study.form.textMsg;
      }
      if (this.userInfo.study.form.pI_Cell != null) {
        this.form.pI_Cell = this.userInfo.study.form.pI_Cell;
      }
      if (this.userInfo.study.form.provider_ID != null) {
        this.form.provider_ID = this.userInfo.study.form.provider_ID;
      }
      if (this.userInfo.study.form.pI_Address_1 != null) {
        this.form.pI_Address_1 = this.userInfo.study.form.pI_Address_1;
      }
      if (this.userInfo.study.form.pI_Address_2 != null) {
        this.form.pI_Address_2 = this.userInfo.study.form.pI_Address_2;
      }
      if (this.userInfo.study.form.pI_City != null) {
        this.form.pI_City = this.userInfo.study.form.pI_City;
      }
      if (this.userInfo.study.form.pI_State != null) {
        this.form.pI_State = this.userInfo.study.form.pI_State;
      }
      if (this.userInfo.study.form.pI_State_Oth != null) {
        this.form.pI_State_Oth = this.userInfo.study.form.pI_State_Oth;
      }
      if (this.userInfo.study.form.pI_Province != null) {
        this.form.pI_Province = this.userInfo.study.form.pI_Province;
      }
      if (this.userInfo.study.form.time_Zone != null) {
        this.form.time_Zone = this.userInfo.study.form.time_Zone;
      }
      if (this.userInfo.study.form.timeZoneOther != null) {
        this.form.timeZoneOther = this.userInfo.study.form.timeZoneOther;
      }
      if (this.userInfo.study.form.country != null) {
        this.form.country = this.userInfo.study.form.country;
      }
      if (this.userInfo.study.form.pI_Zip != null) {
        this.form.pI_Zip = this.userInfo.study.form.pI_Zip;
      }
      if (this.userInfo.study.form.hasORCID != null) {
        this.form.hasORCID = this.userInfo.study.form.hasORCID;
      }
      if (this.userInfo.study.form.rsnNoORCID != null) {
        this.form.rsnNoORCID = this.userInfo.study.form.rsnNoORCID;
      }
      if (this.userInfo.study.form.orcid != null) {
        this.form.orcid = this.userInfo.study.form.orcid;
      }
      // Shipping Info
      if (this.userInfo.study.form.exp_Ship_Acct != null) {
        this.form.exp_Ship_Acct = this.userInfo.study.form.exp_Ship_Acct;
      }
      this.form.shippingNote = this.userInfo.study.form.shippingNote;
      this.form.wkShipment = this.userInfo.study.form.wkShipment;
      this.form.sameasMailing = this.userInfo.study.form.sameasMailing;
      this.form.wK_Contact = this.userInfo.study.form.wK_Contact;
      this.form.wK_Phone = this.userInfo.study.form.wK_Phone;
      this.form.wksameasMailing = this.userInfo.study.form.wksameasMailing;
      if (this.userInfo.study.form.shipCountry != null) {
        this.form.shipCountry = this.userInfo.study.form.shipCountry;
      }
      if (this.userInfo.study.form.ship_Addr_1 != null) {
        this.form.ship_Addr_1 = this.userInfo.study.form.ship_Addr_1;
      }
      if (this.userInfo.study.form.ship_Addr_2 != null) {
        this.form.ship_Addr_2 = this.userInfo.study.form.ship_Addr_2;
      }
      if (this.userInfo.study.form.ship_City != null) {
        this.form.ship_City = this.userInfo.study.form.ship_City;
      }
      if (this.userInfo.study.form.ship_State != null) {
        this.form.ship_State = this.userInfo.study.form.ship_State;
      }
      if (this.userInfo.study.form.wKShipCountry != null) {
        this.form.wKShipCountry = this.userInfo.study.form.wKShipCountry;
      }
      if (this.userInfo.study.form.wK_Ship_Addr_1 != null) {
        this.form.wK_Ship_Addr_1 = this.userInfo.study.form.wK_Ship_Addr_1;
      }
      if (this.userInfo.study.form.wK_Ship_Addr_1 != null) {
        this.form.wK_Ship_Addr_2 = this.userInfo.study.form.wK_Ship_Addr_2;
      }
      if (this.userInfo.study.form.wK_Ship_City != null) {
        this.form.wK_Ship_City = this.userInfo.study.form.wK_Ship_City;
      }
      if (this.userInfo.study.form.wK_Ship_State != null) {
        this.form.wK_Ship_State = this.userInfo.study.form.wK_Ship_State;
      }
      if (this.userInfo.study.form.wK_Ship_Zip != null) {
        this.form.wK_Ship_Zip = this.userInfo.study.form.wK_Ship_Zip;
      }
      if (this.userInfo.study.form.wK_Ship_Province != null) {
        this.form.wK_Ship_Province = this.userInfo.study.form.wK_Ship_Province;
      }
      if (this.userInfo.study.form.wK_Ship_State_Oth != null) {
        this.form.wK_Ship_State_Oth = this.userInfo.study.form.wK_Ship_State_Oth;
      }
      // Research Info
      if (this.userInfo.study.form.study_Title != null) {
        this.form.study_Title = this.userInfo.study.form.study_Title;
      }
      if (this.userInfo.study.form.projAbstract != null) {
        this.form.projAbstract = this.userInfo.study.form.projAbstract;
      }
      if (this.userInfo.study.form.researchMethods != null) {
        this.form.researchMethods = this.userInfo.study.form.researchMethods;
      }
      if (this.userInfo.study.form.isletsReqReason != null) {
        this.form.isletsReqReason = this.userInfo.study.form.isletsReqReason;
      }
      if (this.userInfo.study.form.rationaleFrozen != null) {
        this.form.rationaleFrozen = this.userInfo.study.form.rationaleFrozen;
      }
      if (this.userInfo.study.form.rationaleHistoSlides != null) {
        this.form.rationaleHistoSlides = this.userInfo.study.form.rationaleHistoSlides;
      }
      if (this.userInfo.study.form.rationaleAcinar != null) {
        this.form.rationaleAcinar = this.userInfo.study.form.rationaleAcinar;
      }
      if (this.userInfo.study.form.animalResearch != null) {
        this.form.animalResearch = this.userInfo.study.form.animalResearch;
      }
      this.form.iacuC_Status = this.userInfo.study.form.iacuC_Status;
      this.form.iacuC_App_No = this.userInfo.study.form.iacuC_App_No;
      if (this.userInfo.study.form.iacuC_App_Dt != null) {
        this.form.iacuC_App_Dt = this.userInfo.study.form.iacuC_App_Dt;
      }
      if (this.userInfo.study.form.cellStimulus != null) {
        this.form.cellStimulus = this.userInfo.study.form.cellStimulus;
      }
      if (this.userInfo.study.form.cellDeath != null) {
        this.form.cellDeath = this.userInfo.study.form.cellDeath;
      }
      if (this.userInfo.study.form.type1Diabetes != null) {
        this.form.type1Diabetes = this.userInfo.study.form.type1Diabetes;
      }
      if (this.userInfo.study.form.alphaCells != null) {
        this.form.alphaCells = this.userInfo.study.form.alphaCells;
      }
      if (this.userInfo.study.form.geneticsGenomics != null) {
        this.form.geneticsGenomics = this.userInfo.study.form.geneticsGenomics;
      }
      if (this.userInfo.study.form.otherArea != null) {
        this.form.otherArea = this.userInfo.study.form.otherArea;
      }
      this.form.otherAreaText = this.userInfo.study.form.otherAreaText;
      // Islet Requirements
      if (this.userInfo.study.form.begin_Dt != null) {
        this.form.begin_Dt = this.userInfo.study.form.begin_Dt;
      }
      if (this.userInfo.study.form.comp_Dt != null) {
        this.form.comp_Dt = this.userInfo.study.form.comp_Dt;
      }
      if (this.userInfo.study.form.ieQs_Ideal != null) {
        this.form.ieQs_Ideal = this.userInfo.study.form.ieQs_Ideal;
      }
      if (this.userInfo.study.form.ieQs_Min != null) {
        this.form.ieQs_Min = this.userInfo.study.form.ieQs_Min;
      }
      if (this.userInfo.study.form.purity_Ideal != null) {
        this.form.purity_Ideal = this.userInfo.study.form.purity_Ideal;
      }
      if (this.userInfo.study.form.purity_Min != null) {
        this.form.purity_Min = this.userInfo.study.form.purity_Min;
      }
      this.form.viability_Min = this.userInfo.study.form.viability_Min;
      this.form.viability_Ideal = this.userInfo.study.form.viability_Ideal;
      this.form.freq_Ideal = this.userInfo.study.form.freq_Ideal;
      this.form.freq_Min = this.userInfo.study.form.freq_Min;

      this.form.tot_IEQs_Needed = this.userInfo.study.form.tot_IEQs_Needed;

      this.form.cultured_Ideal = this.userInfo.study.form.cultured_Ideal;
      if (this.userInfo.study.form.cultured_Min != null) {
        this.form.cultured_Min = this.userInfo.study.form.cultured_Min;
      }
      this.form.diabetic_Ideal = this.userInfo.study.form.diabetic_Ideal;
      this.form.diabetic_Min = this.userInfo.study.form.diabetic_Min;
      this.form.race = this.userInfo.study.form.race;
      this.form.aian = this.userInfo.study.form.aian;
      this.form.black = this.userInfo.study.form.black;
      this.form.nhpi = this.userInfo.study.form.nhpi;
      this.form.asian = this.userInfo.study.form.asian;
      this.form.hispanic = this.userInfo.study.form.hispanic;
      this.form.white = this.userInfo.study.form.white;
      this.form.race_Oth = this.userInfo.study.form.race_Oth;
      this.form.web = this.userInfo.study.form.web;
      this.form.cultureLen = this.userInfo.study.form.cultureLen;
      if (this.userInfo.study.form.cultured_Min != null) {
        this.form.cultured_Min = this.userInfo.study.form.cultured_Min;
      }
      if (this.userInfo.study.form.cultureMinDay != null) {
        this.form.cultureMinDay = this.userInfo.study.form.cultureMinDay;
      }
      if (this.userInfo.study.form.cultureMinHr != null) {
        this.form.cultureMinHr = this.userInfo.study.form.cultureMinHr;
      }
      if (this.userInfo.study.form.cultured_Min != null) {
        this.form.cultured_Min = this.userInfo.study.form.cultured_Min;
      }
      if (this.userInfo.study.form.cultureMaxDay != null) {
        this.form.cultureMaxDay = this.userInfo.study.form.cultureMaxDay;
      }
      if (this.userInfo.study.form.cultureMaxHr != null) {
        this.form.cultureMaxHr = this.userInfo.study.form.cultureMaxHr;
      }
      if (this.userInfo.study.form.bmi != null) {
        this.form.bmi = this.userInfo.study.form.bmi;
      }
      if (this.userInfo.study.form.bmiMin1 != null) {
        this.form.bmiMin1 = this.userInfo.study.form.bmiMin1;
      }
      if (this.userInfo.study.form.bmiMax1 != null) {
        this.form.bmiMax1 = this.userInfo.study.form.bmiMax1;
      }
      if (this.userInfo.study.form.bmiMax2 != null) {
        this.form.bmiMax2 = this.userInfo.study.form.bmiMax2;
      }
      if (this.userInfo.study.form.bmiMin2 != null) {
        this.form.bmiMin2 = this.userInfo.study.form.bmiMin2;
      }
      if (this.userInfo.study.form.donorAgeMin != null) {
        this.form.donorAgeMin = this.userInfo.study.form.donorAgeMin;
      }
      if (this.userInfo.study.form.donorAgeMax != null) {
        this.form.donorAgeMax = this.userInfo.study.form.donorAgeMax;
      }
      this.userInfo.study.form.donorAge = this.userInfo.study.form.donorAge;
    }
  }
  get userInfo() {
    return store.userInfo;
  }
  dateConverter(d: any) {
    d = moment.utc(d).format('MM/DD/YYYY');
    if (d !== 'Invalid date') {
      return moment.utc(d).format('MM/DD/YYYY');
    }
  }
  format_date(value: any) {
    if (value) {
      if (moment(String(value)).format('MM/DD/YYYY') !== '01/01/1900') {
        return moment(String(value)).format('MM/DD/YYYY');
      } else {
        return 'NA';
      }
    }
  }
  formatPrice(value: any) {
    if (value !== undefined) {
      value = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      return '$' + value;
    }
  }
  filterKey(e: any) {
    const key = e.key;
    // If is '.' key, stop it
    if (key === '.') {
      return e.preventDefault();
    }
    // OPTIONAL
    // If is 'e' key, stop it
    if (key === 'e') {
      return e.preventDefault();
    }
  }
  validateForm() {
    return this.$v.$invalid;
  }
  submit() {
    this.$v.$touch();
    this.$emit('update', {
      formData: this.form,
      id: 2,
      isValid: !this.$v.$invalid,
      grantList: this.grantList,
    });
  }

  newModal() {
    this.editMode = false;
    this.resetGrantForm();
    this.$bvModal.show('bvModalFunding');
  }
  editModal(rec: any) {
    this.editMode = true;
    this.$bvModal.show('bvModalFunding');
    this.grants.rowId = rec.rowId;
    this.grants.appId = this.userInfo.study.form.appId;
    this.grants.grantTitle = rec.grantTitle;
    this.grants.fundingSource = rec.fundingSource;
    this.grants.grantNo = rec.grantNo;
    this.grants.startDt = rec.startDt;
    // this.grants.duration = rec.duration;
    // this.grants.awardAmt = rec.awardAmt;
    this.grants.supportType = rec.supportType;
    this.grants.supportTypeOth = rec.supportTypeOth;
  }
  resetGrantForm() {
    this.grants.rowId = 0;
    this.grants.grantTitle = '';
    this.grants.fundingSource = '';
    this.grants.grantNo = '';
    this.grants.startDt = '';
    // this.grants.duration = '';
    // this.grants.awardAmt = '';
    this.grants.supportType = '';
    this.grants.supportTypeOth = '';
  }
  confirmDelete(rec: any) {
    this.$swal({
      title: 'Confirm Delete',
      text: 'Are you sure you want to delete the selected funding?',
      icon: 'warning',
      showCancelButton: true,
      customClass: {
        confirmButton: 'btn btn-danger m-1',
        cancelButton: 'btn btn-secondary m-1',
      },
      confirmButtonText: 'Yes, delete it!',
      html: false,
      preConfirm: () => {
        return new Promise((resolve: any) => {
          setTimeout(() => {
            resolve();
          }, 50);
        });
      },
    }).then(async (result: any) => {
      if (result.value) {
        const p = new DeleteGrant({
          rowId: rec.rowId,
          appId: rec.appId,
        });
        const d = await client.delete(p);
        this.userInfo.study.grantList = d.grantList;
        if (d !== undefined) {
          this.$swal('Deleted!', 'Funding has been deleted.', 'success');
        }
      } else if (result.dismiss === 'cancel') {
        this.$swal('Cancelled', 'Delete operation is cancelled.', 'error');
      }
    });
    if (this.userInfo.study.grantList.length !== 1) {
      this.$emit('has-funding-information', true);
    } else {
      this.$emit('has-funding-information', false);
    }
  }
  async confirmUpdate() {
    const p = new EditGrant({
      rowId: this.grants.rowId,
      appID: this.userInfo.study.form.appId,
      grantTitle: this.grants.grantTitle,
      fundingSource: this.grants.fundingSource,
      grantNo: this.grants.grantNo,
      startDt: this.grants.startDt,
      // duration: this.grants.duration,
      // awardAmt: this.grants.awardAmt,
      supportType: this.grants.supportType,
      supportTypeOth: this.grants.supportTypeOth,
    });
    const d = await client.put(p);
    setTimeout(() => {
      this.updateFundingList(d);
    }, 0);
    this.$emit('has-funding-information', true);
  }
  updateFundingList(rec: any) {
    const index = _.findIndex(this.userInfo.study.grantList, {
      rowId: rec.result.rowId,
    });
    if (index > -1) {
      this.$set(this.userInfo.study.grantList, index, rec.result);
    }
  }
  async confirmAdd() {
    const p = new Grants({
      rowId: 0,
      appID: this.userInfo.study.form.appId,
      grantTitle: this.grants.grantTitle,
      fundingSource: this.grants.fundingSource,
      grantNo: this.grants.grantNo,
      startDt: this.grants.startDt,
      // duration: this.grants.duration,
      // awardAmt: this.grants.awardAmt,
      supportType: this.grants.supportType,
      supportTypeOth: this.grants.supportTypeOth,
    });
    const d = await client.post(p);
    setTimeout(() => {
      const item = _.clone(this.grants);
      this.userInfo.study.grantList.push(item);
      this.grantList.push(item);
      this.addFundingList(d);
    }, 0);
    this.$emit('has-funding-information', true);
  }
  addFundingList(rec: any) {
    const index = _.findIndex(this.userInfo.study.grantList, {
      rowId: 0,
    });
    if (index > -1) {
      this.$set(this.userInfo.study.grantList, index, rec.results[index]);
    }
  }
  activated() {
    if (
      this.userInfo.study !== undefined &&
      this.userInfo.study.form !== undefined
    ) {
      Object.assign(this.form, this.userInfo.study.form);
    }
  }
  mounted() {
    this.loadToForm();
    this.validateForm();
    this.iidpIAIActive = `${IIDPconfig.IncludeIAI as string}`;
  }
  loadToForm() {
    bus.$on('userInfo', (payload: any) => {
      Object.assign(this.form, payload.study.form);
    });
  }
  resetIAI() {
    this.form.pilot = false;
  }
  public peerRevChanged(changed: any) {
    if (this.form.peer_Rev_Grant) {
      this.$emit('peer-rev-changed', true);
    } else {
      this.$emit('peer-rev-changed', false);
    }
  }
  public fundsAvaChanged(changed: any) {
    if (this.form.fundsAva) {
      this.$emit('funds-ava-changed', true);
    } else {
      this.$emit('funds-ava-changed', false);
    }
  }
  public nonProfitChanged(changed: any) {
    if (this.form.non_Profit) {
      this.$emit('non-profit-changed', true);
    } else {
      this.$emit('non-profit-changed', false);
    }
  }
  public pilotChanged(changed: any) {
    if (this.form.pilot) {
      this.$bvModal.show('bvModalPilot');
      this.$emit('pilot-changed', true);
    } else {
      this.isHidden = true;
      this.$emit('pilot-changed', false);
    }
  }
  public pilotEligibilityChanged(changed: any) {
    this.isHidden = false;
    if (
      !this.form.isletsFunded ||
      this.form.positionGrantAutoElig
    ) {
      this.$emit('eligibility-changed', true);
    }
    if (
      this.form.isletsFunded ||
      !this.form.positionGrantAutoElig
    ) {
      this.$emit('eligibility-changed', false);
    }
  }
}
